module.exports = __webpack_public_path__ + "static/ogImage-138d5d7f2b8abc04303093a9b16e3d2a.jpg";